import { Provider } from '@angular/core';
import { GeographyService } from './geography.service';
import { provideGeographyApiOrigin, GeographyApiService, GeographyApiOrigin } from '@isaia/geography';
import { GeographyRepository } from './geography.repository';

export function provideGeography(options: { origin: GeographyApiOrigin }): Provider {
  return [provideGeographyApiOrigin(options.origin), GeographyApiService, GeographyService, GeographyRepository];
}
